import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Animation } from '../../animation/animation';
import { QKey, useAnswerContext } from '../../../context';
import { BaseInsight, IBaseInsightTextInterface } from './base-insight';
import { BaseQuestion, IBaseQuestion } from './base-question';
import Lottie from 'lottie-react';
import { animationData, q3bJson } from './lottie';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  image1: {
    position: 'absolute',
    zIndex: 17,
    right: -30,
    top: 190,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 150,
      position: 'absolute',
      left: 10,
      right: 0,
      top:0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  image2: {
    position: 'absolute',
    zIndex: 17,
    right: -35,
    top: 380,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 150,
      position: 'absolute',
      left: -100,
      right: 0,
      top:0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  image3: {
    position: 'absolute',
    zIndex: 15,
    right: -30,
    top: 280,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 111,
      position: 'absolute',
      left: 0,
      right: 0,
      top:0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  image4: {
    position: 'absolute',
    zIndex: 18,
    right: -40,
    top: 250,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 146,
      position: 'absolute',
      left: 15,
      right: 0,
      top:45,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  image5: {
    position: 'absolute',
    zIndex: 15,
    right: -40,
    top: 320,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 150,
      position: 'absolute',
      left: 5,
      top:10,
      right: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  image6: {
    position: 'absolute',
    zIndex: 18,
    right: -15,
    top: 350,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 150,
      position: 'absolute',
      left: 0,
      right: 0,
      top:0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  image7: {
    position: 'absolute',
    zIndex: 10,
    right: -40,
    top: 340,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 137,
      position: 'absolute',
      left: 0,
      right: 0,
      top:-5,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  q1image1: {
    position: 'absolute',
    zIndex: 15,
    right: -50,
    top: 200,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 166,
      position: 'absolute',
      left: 0,
      top:0,
      right: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  q1image2: {
    position: 'absolute',
    zIndex: 25,
    width: 90,
    right: -70,
    top: 180,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 166,
      position: 'absolute',
      left: 0,
      right: 0,
      top:0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  q2image1: {
    position: 'absolute',
    zIndex: 15,
    right: -50,
    top: 400,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 166,
      position: 'absolute',
      left: 0,
      right: 0,
      top:30,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  q3image1: {
    position: 'absolute',
    zIndex: 10,
    right: -50,
    top: 280,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 166,
      position: 'absolute',
      left: 0,
      right: 0,
      top:0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  q4image1: {
    position: 'absolute',
    zIndex: 2,
    right: -50,
    top: 160,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 166,
      position: 'absolute',
      left: 0,
      right: 0,
      top:0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  q5image1: {
    position: 'absolute',
    zIndex: 5,
    right: -50,
    top: 320,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 166,
      position: 'absolute',
      left: 0,
      top:0,
      right: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  q6image1: {
    position: 'absolute',
    zIndex: 5,
    right: -50,
    top: 280,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 166,
      position: 'absolute',
      left: 0,
      top:0,
      right: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  q7image1: {
    position: 'absolute',
    zIndex: 2,
    right: -50,
    top: 330,
    transition: 'transform 0.7s ease-In',
    [theme.breakpoints.down('md')]: {
      width: 166,
      position: 'absolute',
      left: 0,
      top:0,
      right: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
}));

export interface QuestionProps {
  type: 'slider' | 'order' | 'select' | 'select-fw' | 'rank' | 'multi-select';
  questionKey: QKey;
  headerText: string;
  bg: string;
  help: string;
  insight?: {
    lines?: IBaseInsightTextInterface[];
    cite: string;
    addInfo?: boolean;
    info?: string;
    href: string;
  };
  last?: boolean;
  options?: Array<{ text: string; value: number }>;
  src: string;
  color: string;
  progressMain: string;
  changeShowTo: any;
  onNewPage: () => void;
}

export const Question: React.FC<IBaseQuestion & QuestionProps> = React.memo(
  (props) => {
    const {
      onNewPage,
      onNext,
      insight,
      src,
      last = false,
      progressMain,
      questionKey,
      changeShowTo,
      ...rest
    } = props;
    const show = sessionStorage.getItem('showInsight') === 'true';
    const [showInsight, setShowInsight] = useState(show);
    const [height, setHeight] = useState(70);
    const { values, setComplete } = useAnswerContext();
    const rootRef = useRef<HTMLDivElement>(null);
    const {
      root,
      image1,
      image2,
      image3,
      image4,
      image5,
      image6,
      image7,
      q1image1,
      q2image1,
      q3image1,
      q4image1,
      q5image1,
      q6image1,
      q7image1,
    } = useStyles();

    useEffect(() => {
      if (questionKey === 'q1' && !showInsight) {
        changeShowTo(true);
      } else {
        changeShowTo(false);
      }
    }, [questionKey, changeShowTo, showInsight]);

    useEffect(() => {
      sessionStorage.setItem('showInsight', showInsight.toString());
    }, [showInsight]);

    useLayoutEffect(() => {
      if (!rootRef?.current) {
        return;
      }
      const resizeObserver = new ResizeObserver((data) =>
        setHeight((data[0].contentRect.height - 250) / 2),
      );
      resizeObserver.observe(rootRef.current);
      return () => {
        resizeObserver.disconnect();
      };
    }, []);
    const theme = useTheme();
    const matches = !useMediaQuery(theme.breakpoints.up('md'));
    const flow1 = true;

    const moveX = showInsight && insight ? -650 : 0;
    const animatedImage = (
      <Animation animationKey={questionKey} onlyFade>
        {questionKey === 'q1' ? (
          <div
            style={{
              position: 'absolute',
              right: matches ? 0 : 20,
              top: matches ? 40 : -20,
              left: matches ? 0 : undefined,
              width: matches ? 150 : undefined,
              marginLeft: matches ? 'auto' : undefined,
              marginRight: matches ? 'auto' : undefined,
              transform: matches
                ? undefined
                : `translate(${showInsight && insight ? moveX : 20}px, ${
                    showInsight && insight ? height - 20 : 0
                  }px)`,

              transition: 'transform 0.7s ease-In',
            }}
          >
            <img
              className={image1}
              style={{
                transform: matches
                  ? `scaleX(${showInsight && insight ? -1 : 1})`
                  : `translate(${showInsight && insight ? -30 : 0}px, ${
                      showInsight && insight ? -110 : 0
                    }px) scaleX(${showInsight && insight ? -1 : 1})`,
              }}
              src={process.env.PUBLIC_URL + '/q1.svg'}
              alt=""
            />
            <img
              className={q1image1}
              style={{
                transform: matches
                  ? undefined
                  : `translate(${showInsight && insight ? -85 : 0}px, ${
                      showInsight && insight ? -110 : 0
                    }px) rotate(${showInsight && insight ? 180 : 0}deg)`,
              }}
              src={
                process.env.PUBLIC_URL +
                '/q1oval' +
                (matches ? '' : 'f') +
                '.svg'
              }
              alt=""
            />
          </div>
        ) : questionKey === 'q2' ? (
          <div
            style={{
              position: 'absolute',
              right: matches ? 0 : 20,
              top: matches ? 0 : -20,
              left: matches ? 0 : undefined,
              width: matches ? 150 : undefined,
              marginLeft: matches ? 'auto' : undefined,
              marginRight: matches ? 'auto' : undefined,
              transform: matches
                ? undefined
                : `translate(${showInsight && insight ? moveX + 20 : 20}px, ${
                    showInsight && insight ? height + 40 : 0
                  }px)`,

              transition: 'transform 0.7s ease-In',
            }}
          >
            <img
              className={image2}
              style={{
                transform: matches
                  ? `scaleX(${showInsight && insight ? -1 : 1}) translate(${showInsight && insight ? -110 : 0}px, 0px)`
                  : `translate(${showInsight && insight ? -35 : 0}px, ${showInsight && insight ? -420 : 0}px) scaleX(${showInsight && insight ? -1 : 1})`,
              }}
              src={process.env.PUBLIC_URL + '/q2.svg'}
              alt=""
            />
            <img
              className={q2image1}
              style={{
                transform: matches
                  ? `translate(${showInsight && insight ? -15 : 0}px,0)`
                  : `translate(${showInsight && insight ? -105 : 0}px, ${
                      showInsight && insight ? -420 : 0
                    }px) rotate(${showInsight && insight ? 180 : 0}deg)`,
              }}
              src={
                process.env.PUBLIC_URL +
                '/q2oval' +
                (matches ? '' : 'f') +
                '.svg'
              }
              alt=""
            />
          </div>
        ) : questionKey === 'q3' ? (
          <div
            style={{
              position: 'absolute',
              right: matches ? 0 : 20,
              top: matches ? 0 : -20,
              left: matches ? 0 : undefined,
              width: matches ? 150 : undefined,
              marginLeft: matches ? 'auto' : undefined,
              marginRight: matches ? 'auto' : undefined,
                            transform: matches
                ? undefined
                : `translate(${showInsight && insight ? moveX - 10 : 20}px, ${
                    showInsight && insight ? height : 0
                  }px)`,

              transition: 'transform 0.7s ease-In',
            }}
          >
            <img
              className={image3}
              style={{
                transform: matches
                  ? `scaleX(${showInsight && insight ? -1 : 1})`
                  : `translate(${showInsight && insight ? -85 : 0}px, ${
                      showInsight && insight ? -335 : 0
                    }px) scaleX(${showInsight && insight ? -1 : 1})`,
              }}
              src={process.env.PUBLIC_URL + '/q3.svg'}
              alt=""
            />
            <img
              className={q3image1}
              style={{
                transform: matches
                  ? undefined
                  : `translate(${showInsight && insight ? -75 : 0}px, ${
                      showInsight && insight ? -335 : 0
                    }px) rotate(${showInsight && insight ? 180 : 0}deg)`,
              }}
              src={
                process.env.PUBLIC_URL +
                '/q3oval' +
                (matches ? '' : 'f') +
                '.svg'
              }
              alt=""
            />
          </div>
        ) : questionKey === 'q4' ? (
          <div
            style={{
              position: 'absolute',
              right: matches ? 0 : 20,
              top: matches ? 0 : -20,
              left: matches ? 0 : undefined,
              width: matches ? 150 : undefined,
              marginLeft: matches ? 'auto' : undefined,
              marginRight: matches ? 'auto' : undefined,
              transform: matches
                ? undefined
                : `translate(${showInsight && insight ? moveX : 20}px, ${
                    showInsight && insight ? height + 80 : 0
                  }px)`,

              transition: 'transform 0.7s ease-In',
            }}
          >
            <img
              className={image4}
              style={{
                transform: matches
                  ? `scaleX(${showInsight && insight ? -1 : 1})`
                  : `translate(${showInsight && insight ? -85 : 0}px, ${
                      showInsight && insight ? -230 : 0
                    }px) scaleX(${showInsight && insight ? -1 : 1})`,
              }}
              src={process.env.PUBLIC_URL + '/q4.svg'}
              alt=""
            />
            <img
              className={q4image1}
              style={{
                transform: matches
                  ? undefined
                  : `translate(${showInsight && insight ? -85 : 0}px, ${
                      showInsight && insight ? -230 : 0
                    }px) rotate(${showInsight && insight ? 180 : 0}deg)`,
              }}
              src={
                process.env.PUBLIC_URL +
                '/q4oval' +
                (matches ? '' : 'f') +
                '.svg'
              }
              alt=""
            />
          </div>
        ) : questionKey === 'q5' ? (
          <div
            style={{
              position: 'absolute',
              right: matches ? 0 : 20,
              top: matches ? 0 : -20,
              left: matches ? 0 : undefined,
              width: matches ? 150 : undefined,
              marginLeft: matches ? 'auto' : undefined,
              marginRight: matches ? 'auto' : undefined,
              transform: matches
                ? undefined
                : `translate(${showInsight && insight ? moveX : 20}px, ${
                    showInsight && insight ? height + 80 : 0
                  }px)`,

              transition: 'transform 0.7s ease-In',
            }}
          >
            <img
              className={image5}
              style={{
                transform: matches
                  ? `scaleX(${showInsight && insight ? -1 : 1})`
                  : `translate(${showInsight && insight ? -110 : 0}px, ${
                      showInsight && insight ? -510 : 0
                    }px) scaleX(${showInsight && insight ? -1 : 1})`,
              }}
              src={process.env.PUBLIC_URL + '/q5.svg'}
              alt=""
            />
            <img
              className={q5image1}
              style={{
                transform: matches
                  ? undefined
                  : `translate(${showInsight && insight ? -85 : 0}px, ${
                      showInsight && insight ? -530 : 0
                    }px) rotate(${showInsight && insight ? 180 : 0}deg)`,
              }}
              src={
                process.env.PUBLIC_URL +
                '/q1oval' +
                (matches ? '' : 'f') +
                '.svg'
              }
              alt=""
            />
          </div>
        ) : questionKey === 'q6' ? (
          <div
            style={{
              position: 'absolute',
              right: matches ? 0 : 20,
              top: matches ? 0 : -20,
              left: matches ? 0 : undefined,
              width: matches ? 150 : undefined,
              marginLeft: matches ? 'auto' : undefined,
              marginRight: matches ? 'auto' : undefined,
              transform: matches
                ? undefined
                : `translate(${showInsight && insight ? moveX + 80 : 20}px, ${
                    showInsight && insight ? height + 80 : 0
                  }px)`,

              transition: 'transform 0.7s ease-In',
            }}
          >
            <img
              className={image6}
              style={{
                transform: matches
                  ?  `scaleX(${showInsight && insight ? -1 : 1})`
                  : `translate(${showInsight && insight ? -70 : 0}px, ${
                      showInsight && insight ? -340 : 0
                    }px) scaleX(${showInsight && insight ? -1 : 1})`,
              }}
              src={process.env.PUBLIC_URL + '/q6.svg'}
              alt=""
            />
            <img
              className={q6image1}
              style={{
                transform: matches
                  ? undefined
                  : `translate(${showInsight && insight ? -165 : 0}px, ${
                      showInsight && insight ? -300 : 0
                    }px) rotate(${showInsight && insight ? 180 : 0}deg)`,
              }}
              src={
                process.env.PUBLIC_URL +
                '/q2oval' +
                (matches ? '' : 'f') +
                '.svg'
              }
              alt=""
            />
          </div>
        ) : (
          <div
            style={{
              position: 'absolute',
              right: matches ? 0 : 20,
              top: matches ? 0 : -20,
              left: matches ? 0 : undefined,
              width: matches ? 150 : undefined,
              marginLeft: matches ? 'auto' : undefined,
              marginRight: matches ? 'auto' : undefined,
              transform: matches
                ? undefined
                : `translate(${showInsight && insight ? moveX : 20}px, ${
                    showInsight && insight ? height + 80 : 0
                  }px)`,

              transition: 'transform 0.7s ease-In',
            }}
          >
            <img
              className={image7}
              style={{
                transform: matches
                  ?  `scaleX(${showInsight && insight ? -1 : 1})`
                  : `translate(${showInsight && insight ? -105 : 0}px, ${
                      showInsight && insight ? -600 : 0
                    }px) scaleX(${showInsight && insight ? -1 : 1})`,
              }}
              src={process.env.PUBLIC_URL + '/q7.svg'}
              alt=""
            />
            <img
              className={q7image1}
              style={{
                transform: matches
                  ? undefined
                  : `translate(${showInsight && insight ? -85 : 0}px, ${
                      showInsight && insight ? -600 : 0
                    }px) rotate(${showInsight && insight ? 180 : 0}deg)`,
              }}
              src={
                process.env.PUBLIC_URL +
                '/q3oval' +
                (matches ? '' : 'f') +
                '.svg'
              }
              alt=""
            />
          </div>
        )}
      </Animation>
    );

    return (
      <div className={root} ref={rootRef}>
        {!matches ? animatedImage : null}
        {showInsight && insight ? (
          <Animation animationKey={showInsight} timeout={400}>
            <BaseInsight
              questionKey={questionKey}
              animatedImage={matches ? animatedImage : undefined}
              nextText={
                {
                  text: last ? 'Complete assessment' : 'Continue',
                  isHighlihted: false,
                } as IBaseInsightTextInterface
              }
              progressMain={progressMain}
              {...insight}
              onNext={() => {
                if (last) {
                  setComplete();
                  return;
                }
                onNext();
                setShowInsight(false);
              }}
              onBack={() => {
                setShowInsight(false);
              }}
            />
          </Animation>
        ) : (
          <Animation animationKey={props.questionKey} timeout={200}>
            <BaseQuestion
              questionKey={questionKey}
              {...rest}
              nextText={last ? 'Continue' : undefined}
              animatedImage={matches ? animatedImage : undefined}
              onNext={() => {
                if (insight) {
                  onNewPage();
                  setShowInsight(true);
                  return;
                }
                onNext();
              }}
            />
          </Animation>
        )}
      </div>
    );
  },
);
